import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useIntl } from 'react-intl';

import {
    CircleSpinner,
    ComponentSelector,
    useSession,
} from '@ratehub/base-ui';

import Pages from '../definitions/Pages';
import createContext from '../functions/createContext';

import AccountModal from './AccountModal';
import PageProfileDetails from './PageProfileDetails';
import PageSavedDocuments from './PageSavedDocuments';


/* When creating VM, create consts for the values of the tab ChoiceField */
function AccountApp({ portalBannerId, insuranceProviders, includeRouting, onCreateState, className, ...otherProps }) {
    const intl = useIntl();

    const sessionStore = useSession();

    const [ context ] = useState(() => createContext({
        sessionStore,

        insuranceProviders,

        includeRouting,

        locale: intl.locale,
    }));

    useEffect(
        () => {
            onCreateState?.(context);
        },
        [ onCreateState, context ],
    );

    const { viewStore } = context;

    const isComponentReady = includeRouting ? context.isRoutingEnabled : context.isReady;

    return (
        <section
            className={className}
            {...otherProps}
        >
            <Choose>
                <When condition={context.isLoggedIn === true && isComponentReady}>
                    <ComponentSelector
                        componentId={viewStore.selectedPageId}
                        componentMap={{
                            [Pages.profileDetails.id]: PageProfileDetails,
                            [Pages.myQuotes.id]: PageSavedDocuments,
                        }}
                        model={viewStore.selectedPageModel}
                        portalBannerId={portalBannerId}
                    />
                </When>
                <When condition={context.shouldShowSignInModal && isComponentReady}>
                    <AccountModal
                        modalModel={viewStore.accountModal}
                        onClose={viewStore.closeAccountModal}
                        flowOptions={viewStore.flowOptions}
                    />
                </When>
                <Otherwise>
                    <CircleSpinner />
                </Otherwise>
            </Choose>
        </section>
    );
}

AccountApp.propTypes = {
    portalBannerId: PropTypes.string.isRequired,

    insuranceProviders: PropTypes.shape({
        insurers: PropTypes.array,
        brokers: PropTypes.array,
    }),
    includeRouting: PropTypes.bool,

    onCreateState: PropTypes.func,
    className: PropTypes.string,
};

AccountApp.defaultProps = {
    insuranceProviders: undefined,
    includeRouting: true,

    onCreateState: undefined,
    className: undefined,
};

export default observer(AccountApp);
